/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { informationStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsInformation";
import { contentText, titleText } from "@monsma/App/WidgetExtensions/OrderDetails/OrderDateExtension";
import { css } from "styled-components";

informationStyles.invoiceInformationGridContainer = {
    gap: 30,
    css: css`
        div[class^="GridOffset"] {
            width: calc(100% + 30px);
        }
    `,
};

informationStyles.invoiceInformationGridItems = {};

informationStyles.informationGridContainer = {
    gap: 15,
};

informationStyles.headingAndTextStyles = {
    heading: titleText,
    text: contentText,
};

informationStyles.statusGridItem = {
    width: [12, 6, 4, 4, 4],
};

informationStyles.invoiceDateGridItem = informationStyles.statusGridItem;

informationStyles.salespersonGridItem = informationStyles.statusGridItem;

informationStyles.termsGridItem = informationStyles.statusGridItem;

informationStyles.poNumberGridItem = informationStyles.statusGridItem;

informationStyles.dueDateGridItem = informationStyles.statusGridItem;

informationStyles.vatNumberGridItem = informationStyles.statusGridItem;

informationStyles.billingAddressGridItem = {
    width: [12, 6, 6, 6, 6],
};

informationStyles.shippingAddressGridItem = {
    width: [12, 6, 6, 6, 6],
};
